module.exports = __webpack_public_path__ + "static/media/snapshot2.8b09bbc2.png";